export default __webpack_public_path__ + "581fe532e7e22bc5bd4a5226ff4fbb2f.png";